import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import AutoWrapInput from "../../InputContainers/AutoWrapInput";
import {deepCompare} from "../../../../variables/tools";
import i18n from "../../../../i18n";
import * as actions from "../../../../store/actions";
import {useDispatch, useSelector} from "react-redux";

const Group = props => {
    const dispatch = useDispatch();
    const groups   = useSelector(state => state.groups.groups);
    const loading  = useSelector(state => state.groups.loading);
    useEffect(() => {dispatch(actions.groups.loadIfNeeded())}, [dispatch]);

    let groupOptions = [];
    if (!loading && groups) {
        groupOptions = groups.map(group => ({value: group.uuid, label: group.name}));
        if (props.settings.hideGroup) {
            groupOptions = groupOptions.filter(group => group.value !== props.settings.hideGroup);
        }
    }

    return (
        <AutoWrapInput name={props.name} settings={props.settings} stacked={props.stacked}>
            {!loading && groups ? (
                <Select
                    {...props.settings.elementConfig}
                    name={props.name}
                    onChange={option => props.handlers.change(option.value, props.name)}
                    onFocus={() => props.handlers.focus(props.name, true)}
                    onBlur={() => props.handlers.focus(props.name, false)}
                    noOptionsMessage={() => i18n.noGroups}
                    classNamePrefix="react-select"
                    className="react-select"
                    value={groupOptions.filter(group => group.value === props.settings.value)}
                    options={groupOptions}
                    ref={props.innerRef}
                />
            ) : <p>{i18n.loading}</p>}
        </AutoWrapInput>
    );
};

Group.propTypes = {
    name:     PropTypes.string.isRequired,
    settings: PropTypes.object.isRequired,
    handlers: PropTypes.object.isRequired,
    innerRef: PropTypes.object,
    stacked:  PropTypes.bool
};

export default React.memo(Group, (prevProps, nextProps) => (
    prevProps.settings.value === nextProps.settings.value &&
    prevProps.settings.focused === nextProps.settings.focused &&
    prevProps.settings.valid === nextProps.settings.valid &&
    deepCompare(prevProps.settings.options, nextProps.settings.options)
));
